import { render, staticRenderFns } from "./impacted-site.vue?vue&type=template&id=2627b0e4"
import script from "./impacted-site.vue?vue&type=script&lang=js"
export * from "./impacted-site.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports